import { Component, Input, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import {
  HelperService,
  HTTPService,
  FormatService,
  ExportService,
} from 'app/services';

@Component({
  selector: 'app-update-inspections-modal',
  templateUrl: './update-inspections-modal.component.html',
  styleUrls: ['./update-inspections-modal.component.scss'],
})
export class UpdateInspectionsModalComponent implements OnInit {
  inspectionItemId: String;
  inspectionItemCategoryId: String;
  inspectionItemCategoryTitle: String;
  inspectionItemTitle: String;

  cannedInspections = <any>[];
  selectedCannedInspections = <any>{};

  isDeleteDialog: boolean = false;
  isOpeningFromUpdate: boolean = false;

  processing: boolean = false;

  dialogDescription = '';
  dialogTitle = '';

  constructor(
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public helperService: HelperService,
    private httpService: HTTPService
  ) {}

  ngOnInit() {
    const {
      inspectionItemId,
      inspectionItemTitle,
      inspectionItemCategoryId,
      inspectionItemCategoryTitle,
      cannedInspections,
      isDeleteDialog,
      isOpeningFromUpdate,
    } = this.dConfig.data;

    this.inspectionItemId = inspectionItemId;
    this.inspectionItemCategoryId = inspectionItemCategoryId;
    this.inspectionItemTitle = inspectionItemTitle;
    this.inspectionItemCategoryTitle = inspectionItemCategoryTitle;
    this.cannedInspections = cannedInspections;
    this.isDeleteDialog = isDeleteDialog;
    this.isOpeningFromUpdate = isOpeningFromUpdate;

    if (isDeleteDialog) {
      if (isOpeningFromUpdate) {
        this.dialogTitle = `Update items from following Inspections?`;
      } else {
        this.dialogTitle = `Delete items from following Inspections?`;
      }
    } else {
      this.dialogTitle = `Update inspections linked with “${this.inspectionItemCategoryTitle}”`;
    }

    if (isDeleteDialog) {
      if (isOpeningFromUpdate) {
        this.dialogDescription = `Updating inspection item “${this.inspectionItemTitle}” category will remove it from following inspections`;
      } else {
        this.dialogDescription = `Deleting inspection item “${this.inspectionItemTitle}” will remove it from following inspections`;
      }
    } else {
      this.dialogDescription = `Following inspection checklists are linked with category “${this.inspectionItemCategoryTitle}”. Inspection item
      “${this.inspectionItemTitle}” will be added to all the inspections selected below`;
    }

    // get inspection checklists where this item is present
    this.cannedInspections.forEach((inspection) => {
      this.selectedCannedInspections[inspection._id] = true;
    });
  }

  onSubmit() {
    if (!this.isDeleteDialog) {
      const selectedInspectionFilter = Object.keys(
        this.selectedCannedInspections
      ).filter((i) => this.selectedCannedInspections[i]);

      this.processing = true;
      this.httpService
        .addItemInInspections({
          inspectionIds: selectedInspectionFilter,
          itemId: this.inspectionItemId,
          categoryId: this.inspectionItemCategoryId,
        })
        .then((res) => {
          this.helperService.showToaster(
            'success',
            'Inspection checklist updated'
          );
          this.ref.close({
            isSuccess: true,
          });
        })
        .catch((err) => {
          this.helperService.showToaster(
            'error',
            'Error in inspection checklist update'
          );
        })
        .finally(() => (this.processing = false));
    } else {
      const selectedInspectionFilter = this.cannedInspections.map(
        (ele) => ele._id
      );

      this.httpService
        .removeItemInInspections({
          inspectionIds: selectedInspectionFilter,
          itemId: this.inspectionItemId,
          categoryId: this.inspectionItemCategoryId,
        })
        .then((res) => {
          this.ref.close({
            isSuccess: true,
          });
          this.helperService.showToaster(
            'Success',
            'Inspection checklist updated'
          );
        })
        .catch((err) => {
          this.helperService.showToaster(
            'error',
            'Error in inspection checklist update'
          );
        })
        .finally(() => (this.processing = false));
    }
  }

  handleCheckboxSelect(event, inspectionId) {
    try {
      this.selectedCannedInspections[inspectionId] = event;
    } catch (error) {}
  }

  closeModal() {
    this.ref.close({
      isSuccess: false,
    });
  }
}
